import { makeStyles } from 'lib/components';

export default makeStyles(() => ({
  toastMessage: {
    position: 'absolute',
    top: '19px',
    padding: '16px',
    height: '56px',
    width: '100%',
    zIndex: '150',
  },
  alertMsg: {
    width: '100%',
    margin: '0 20px',
  },
  toastMessageMobile: {
    position: 'absolute',
    top: 0,
    width: '100%',
    zIndex: '150',
    borderRadius: 0,
    alignItems: 'center',
  },
}));
